import * as React from "react";
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { UserConditionType, GenderType, TimePresetType } from "../../../common/enums";
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { UserConditionModel } from '../../../models/user/userConditionModel';
import { UserConditionTypeModel } from "../../../models/user/userConditionTypeModel";
import { getEnumLabel } from '../../../common/functions/helperFunctions';
import CSSTransition from 'react-transition-group/CSSTransition';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faTimesCircle, faCheck, faTimes, faBan, faPlay, faStop, faCircle, faFilter, faInfoCircle, faChartBar, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { faBluetooth } from '@fortawesome/free-brands-svg-icons';
import TextField from '@material-ui/core/TextField';
import Growl from '../../../common/components/alertMessage/growl';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { UserPersonalConditionModel } from '../../../models/user/userPersonalConditionModel';
import Spinner from "../../../common/components/spinner/spinner";
import UserConditionService from "../../../services/userConditionService";
import BluetoothService from "../../../services/bluetoothService";
import { MuiPickersUtilsProvider, DateTimePicker, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import * as Constants from '../../../common/constants';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import UserConditionCharts from './userConditionCharts';
import Card from '@material-ui/core/Card';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import CardContent from '@material-ui/core/CardContent';
import Paginator from '../../../common/components/paginator/paginator'
import { ConditionUnitRangeModel } from "../../../models/user/conditionUnitRangeModel";
import { DropdownModel } from "../../../models/dropdownModel";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { UserConditionTypeFilterModel } from '../../../models/user/userConditionTypeFilterModel';
import Popover from '@material-ui/core/Popover';
import UserConditionBars from './userConditionBars';

interface IProps {
	cancelClick: any,
	isVisible: boolean,
	selectedConditionId: number,
	dialogHeader: string;
	lang: string;
}

interface IState {
	currentCondition: UserConditionModel;
	isLoading: boolean;
	validationMessage: string;
	addNew: boolean;
	isLoadingSecond: boolean;
	personalConditions: Array<UserPersonalConditionModel>;
	isVisibleConfirmDialog: boolean;
	deleteValidationMessage: string;
	personalCondition: ConditionDropdownModel;
	anchorEl: any;
	popover: boolean;
	bluetoothDialog: boolean;
	bluetoothValue: string;
	isLoadingBluetooth: boolean;
	selectedType: UserConditionTypeModel;
	newConditionType: UserConditionTypeModel;
	isBluetoothLogStart: boolean;
	heartRateChangeArray: Array<UserConditionTypeModel>;
	isVisibleConfirmTypeDialog: boolean;
	condIndex: number;
	totalRecordsCount: number;
	numberOfPages: number;
	page: number;
	from: number;
	numberOfRows: number;
	conditionUnitRanges: Array<ConditionUnitRangeModel>;
	selectedRange: ConditionUnitRangeModel;
	rangesDropdown: Array<DropdownModel>;
	selectedRangeID: number;
	isVisibleDropdown: boolean;
	userAge: number;
	userGender: number;
	bottomNumber: number;
	topNumber: number;
	isVisibleFilterDialog: boolean;
	filterByDates: boolean;
	currentFilters: UserConditionTypeFilterModel;
	filters: UserConditionTypeFilterModel;
	timeDropdown: Array<DropdownModel>;
	selectedTime: number;
	canChooseDates: boolean;
	infoPopover: boolean;
	infoAchor: any;
	isChartsView: boolean;
}

const isChrome = !!window['chrome'] && (!!window['chrome']['webstore'] || !!window['chrome']['runtime']);

class UserConditionAddEditDialog extends React.Component<IProps, IState> {
	growl: any;
	growlSecond: any;
	growlBluetooth: any;
	userConditionService = new UserConditionService();
	bluetoothService = new BluetoothService();
	heartRateCharacteristic: any;
	temperatureCharacteristic: any;
	secInterval: any;
	numberOfRows = window.innerWidth < Constants.device.desktop ? 5 : 10;
	initFrom = 0;

	constructor(props: IProps) {
		super(props);

		this.state = {
			currentCondition: new UserConditionModel(),
			isLoading: false,
			validationMessage: '',
			addNew: false,
			isLoadingSecond: false,
			personalConditions: Array<UserPersonalConditionModel>(0),
			isVisibleConfirmDialog: false,
			deleteValidationMessage: '',
			personalCondition: new ConditionDropdownModel(),
			anchorEl: null,
			popover: false,
			bluetoothDialog: false,
			bluetoothValue: '',
			isLoadingBluetooth: false,
			selectedType: new UserConditionTypeModel(),
			newConditionType: new UserConditionTypeModel(),
			isBluetoothLogStart: false,
			heartRateChangeArray: new Array<UserConditionTypeModel>(0),
			isVisibleConfirmTypeDialog: false,
			condIndex: 0,
			totalRecordsCount: 0,
			numberOfPages: 0,
			numberOfRows: this.numberOfRows,
			page: 1,
			from: this.initFrom,
			conditionUnitRanges: new Array<ConditionUnitRangeModel>(0),
			selectedRange: new ConditionUnitRangeModel,
			rangesDropdown: new Array<DropdownModel>(),
			selectedRangeID: 0,
			isVisibleDropdown: false,
			userAge: 0,
			userGender: 0,
			bottomNumber: 0,
			topNumber: 0,
			isVisibleFilterDialog: false,
			filterByDates: false,
			currentFilters: new UserConditionTypeFilterModel(),
			filters: new UserConditionTypeFilterModel(),
			timeDropdown: Array<DropdownModel>(0),
			selectedTime: 1,
			canChooseDates: false,
			infoPopover: false,
			infoAchor: null,
			isChartsView: true
		};
	}

	componentDidMount() {
		let locStoChart = localStorage.getItem('isChartView');
		let isChartView: boolean = true;
		if (locStoChart) {
			isChartView = locStoChart == "true" ? true : false;
		}
		this.setState({ isChartsView: isChartView });
		this.getCondition(1, this.state.numberOfRows, true);
	}

	handleSaveButton = (close, conditionTypes: Array<UserConditionTypeModel>, event?) => {
		if (event) {
			event.preventDefault();
		}
		this.setState({ isLoading: true })

		if (this.heartRateCharacteristic) {
			this.heartRateCharacteristic.stopNotifications();
		}

		if (this.temperatureCharacteristic) {
			this.temperatureCharacteristic.stopNotifications();
		}

		for (let i = 0; i < this.state.currentCondition.userConditionTypes.length; i++) {
			if (!this.state.currentCondition.userConditionTypes[i].userConditionValue || this.state.currentCondition.userConditionTypes[i].userConditionValue.trim() == '') {
				this.growl.show({ severity: 'error', summary: Translate('NotAllEntered') });
				return;
			}
		}
		const condition = this.state.currentCondition;

		//condition.conditionDate = fomatDateTimeAsString(new Date(condition.conditionDate));		
		this.userConditionService.updateUserCondition(condition.userConditionId, conditionTypes)
			.then(
				(data) => {
					this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
					this.setState({ isLoading: false });
					this.getCondition(1, this.state.numberOfRows, true);
				},
				error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				}
			);
	}

	rangesToDropdown = (isInit: boolean) => {
		if (!this.state.currentCondition.isSystemType) {
			let newrange: ConditionUnitRangeModel = new ConditionUnitRangeModel();
			if (this.state.currentCondition.personalMinValue) {
				newrange.minValue = JSON.stringify(this.state.currentCondition.personalMinValue);
			}
			if (this.state.currentCondition.personalMaxValue) {
				newrange.maxValue = JSON.stringify(this.state.currentCondition.personalMaxValue);
			}
			this.setState({ selectedRange: newrange, isVisibleDropdown: false });
		}
		else {
			if (this.state.conditionUnitRanges && this.state.conditionUnitRanges.length > 0 && isInit) {
				if (this.state.conditionUnitRanges.length > 1) {
					let ranges = [...this.state.conditionUnitRanges];
					let allItems = Array<DropdownModel>(0);
					let found: ConditionUnitRangeModel = ranges[0];

					for (let unit of ranges) {
						let dropDown = new DropdownModel();
						dropDown.value = unit.conditionUnitRangeId;
						dropDown.label = (unit.genderTypeId > 0 ? this.getGender(unit.genderTypeId) + "; " : "") +
							(unit.minAge > 0 && unit.maxAge > 0 ? unit.minAge + '-' + unit.maxAge + " " + Translate('AgeAbb') : "") +
							(unit.maxAge > 0 && unit.minAge <= 0 ? Translate('Under') + ' ' + unit.maxAge + " " + Translate('AgeAbb') : "") +
							(unit.maxAge <= 0 && unit.minAge > 0 ? Translate("Over") + ' ' + unit.minAge + " " + Translate('AgeAbb') : "");
						allItems.push(dropDown);
					}

					if (this.state.userGender && !this.state.userAge) {
						for (let r of ranges) {
							if (r.genderTypeId && r.genderTypeId == this.state.userGender) {
								found = r;
							}
						}
					}

					if (this.state.userAge && !this.state.userGender) {
						for (let r of ranges) {
							if (r.minAge && r.maxAge && this.state.userAge > r.minAge && this.state.userAge < r.maxAge) {
								found = r;
							}

							if (r.minAge && !r.maxAge && this.state.userAge > r.minAge) {
								found = r;
							}

							if (!r.minAge && r.maxAge && this.state.userAge < r.maxAge) {
								found = r;
							}
						}
					}

					if (this.state.userAge && this.state.userGender) {
						for (let r of ranges) {
							if (r.minAge && r.maxAge && this.state.userAge > r.minAge && this.state.userAge < r.maxAge && (!r.genderTypeId || r.genderTypeId == this.state.userGender)) {
								found = r;
							}

							if (r.minAge && !r.maxAge && this.state.userAge > r.minAge && (!r.genderTypeId || r.genderTypeId == this.state.userGender)) {
								found = r;
							}

							if (!r.minAge && r.maxAge && this.state.userAge < r.maxAge && (!r.genderTypeId || r.genderTypeId == this.state.userGender)) {
								found = r;
							}

							if (!r.minAge && !r.maxAge && r.genderTypeId == this.state.userGender) {
								found = r;
							}
						}
					}
					this.setState({ isVisibleDropdown: true, rangesDropdown: allItems, selectedRangeID: found.conditionUnitRangeId, selectedRange: found });
				}
				else {
					this.setState({ isVisibleDropdown: false, selectedRange: this.state.conditionUnitRanges[0] });
				}
			}
		}
	}

	getGender = (gender: number) => {
		return gender == GenderType.Male ? Translate('Male') : Translate('Female');
	}

	getCondition = (page: number, numberOfRows: number, isInit: boolean) => {
		let from = (page - 1) * this.state.numberOfRows;

		this.setState({
			isLoading: true,
		});

		let filter: UserConditionTypeFilterModel = new UserConditionTypeFilterModel();

		if (this.state.filterByDates && this.state.filters.startDate) {
			filter.startDate = HelperFunctions.fomatDateTimeAsString(new Date(this.state.filters.startDate));
		}

		if (this.state.filterByDates && this.state.filters.endDate) {
			filter.endDate = HelperFunctions.fomatDateTimeAsString(new Date(this.state.filters.endDate));
		}

		this.userConditionService.getCondition(this.props.selectedConditionId, from, numberOfRows, filter)
			.then(
				(data) => {
					if (!this.state.conditionUnitRanges || this.state.conditionUnitRanges.length == 0) {
						this.setState({
							isLoading: false,
							currentCondition: data.condition,
							from: from,
							totalRecordsCount: data.totalRecordsCount,
							conditionUnitRanges: data.conditionUnitRanges,
							selectedRange: data.conditionUnitRanges ? data.conditionUnitRanges[0] : new ConditionUnitRangeModel(),
							userAge: data.userAge,
							userGender: data.userGender,
							numberOfPages: (data.totalRecordsCount % this.state.numberOfRows > 0 ?
								data.totalRecordsCount / this.state.numberOfRows + 1 : data.totalRecordsCount / this.state.numberOfRows)
						}, () => this.rangesToDropdown(isInit));
					}
					else {
						this.setState({
							isLoading: false,
							currentCondition: data.condition,
							from: from,
							totalRecordsCount: data.totalRecordsCount,
							userAge: data.userAge,
							userGender: data.userGender,
							numberOfPages: (data.totalRecordsCount % this.state.numberOfRows > 0 ?
								data.totalRecordsCount / this.state.numberOfRows + 1 : data.totalRecordsCount / this.state.numberOfRows)
						});
					}
				},
				error => {
					this.growl.show({ severity: 'error', summary: error.message });
					this.setState({
						isLoading: false
					});
				}
			);
	}

	handleCancelButton = () => {
		if (this.heartRateCharacteristic) {
			this.heartRateCharacteristic.stopNotifications();
		}

		if (this.temperatureCharacteristic) {
			this.temperatureCharacteristic.stopNotifications();
		}
		clearInterval(this.secInterval);
		this.props.cancelClick();
	}

	handleChange = (props: UserConditionTypeModel, value) => {
		const condition: UserConditionModel = { ...this.state.currentCondition };
		const conditions: Array<UserConditionTypeModel> = [...condition.userConditionTypes];
		let founded = conditions.findIndex(r => r.userConditionToUserConditionTypeId == props.userConditionToUserConditionTypeId);
		conditions[founded].userConditionValue = value;
		condition.userConditionTypes = [...conditions];
		this.setState({ currentCondition: { ...condition } });
	};

	addNewToList = (event) => {
		event.preventDefault();
		this.setState({ addNew: true });
	}

	handleCancelAddNewButton = () => {
		clearInterval(this.secInterval);
		this.setState({ addNew: false, newConditionType: new UserConditionTypeModel(), bottomNumber: 0, topNumber: 0 });
	}

	handleUserConditionTypeRemoveClick = (event, index: number) => {
		event.preventDefault();
		this.setState({ condIndex: index, isVisibleConfirmTypeDialog: true, deleteValidationMessage: Translate("ConditionTypeConfirm") });
	}

	handleUserConditionBluetoothClick = (condType: UserConditionType, event?) => {
		if (event) {
			event.preventDefault();
		}
		this.setState({ isLoadingBluetooth: true });

		let isFloat = false;
		let serviceName = '';
		let characteristicName = '';

		switch (condType) {

			case UserConditionType.Weight:
				serviceName = 'battery_service';
				characteristicName = 'battery_level';
				isFloat = false;
				this.getBateryValue(serviceName, characteristicName, isFloat);
				break;

			case UserConditionType.HeartRate:
				serviceName = 'heart_rate';
				characteristicName = 'heart_rate_measurement';
				this.addEventListener(serviceName, characteristicName);
				break;

			case UserConditionType.Temperature:
				serviceName = 'health_thermometer';
				characteristicName = 'temperature_measurement';
				this.addEventListener(serviceName, characteristicName);
				isFloat = true;
				break;
		}
	}

	getBateryValue = (serviceName, characteristicName, isFloat) => {
		this.bluetoothService.getValue(serviceName, characteristicName, isFloat)
			.then(
				(data) => {
					let userConditionType = new UserConditionTypeModel();

					// userConditionType.userConditionTypeId = UserConditionType.Weight;
					// userConditionType.isSystemType = true;

					this.handleChange(userConditionType, data + '');
					this.setState({
						isLoading: false,
					});
				},
				error => {
					this.growl.show({ severity: 'error', summary: Translate("The connection was interrupted") });
					this.setState({
						isLoading: false
					});
				}
			);
	}

	addEventListener = (serviceName, characteristicName) => {
		this.bluetoothService.getCharacteristic(serviceName, characteristicName)
			.then(
				(characteristic) => {
					characteristic.startNotifications()
						.then(
							char => {
								if (serviceName == 'heart_rate') {
									this.heartRateCharacteristic = characteristic;
									this.heartRateCharacteristic.addEventListener('characteristicvaluechanged',
										(event) => this.onHeartRateChanged(event));
								}

								if (serviceName == 'health_thermometer') {
									this.temperatureCharacteristic = characteristic;
									this.temperatureCharacteristic.addEventListener('characteristicvaluechanged',
										(event) => this.onTemperatureChanged(event));
								}
							},
							error => {
								this.growlBluetooth.show({ severity: 'error', summary: Translate("The connection was interrupted") });
								this.setState({
									isLoadingBluetooth: false
								});
							}
						)
				},
				error => {
					this.growlBluetooth.show({ severity: 'error', summary: Translate("The connection was interrupted") });
					this.setState({
						isLoadingBluetooth: false
					});
				}
			);
	}

	onHeartRateChanged = (event) => {
		let characteristic = event.target;
		let data = this.bluetoothService.parseHeartRate(characteristic.value);
		if (this.state.isBluetoothLogStart) {
			let userConditionType = new UserConditionTypeModel();
			let condTypes: Array<UserConditionTypeModel> = [...this.state.heartRateChangeArray];
			userConditionType.conditionDate = new Date().toUTCString();
			userConditionType.userConditionValue = data.heartRate + '';
			condTypes.push(userConditionType);
			if (this.state.bluetoothValue != data.heartRate + '') {
				this.setState({
					isLoadingBluetooth: false,
					bluetoothValue: data.heartRate + '',
					heartRateChangeArray: [...condTypes]
				});
			}
		}
		else {
			this.setState({
				isLoadingBluetooth: false,
				bluetoothValue: data.heartRate + ''
			});
		}
	}

	onTemperatureChanged = (event) => {
		let characteristic = event.target;
		let data = this.bluetoothService.parseTemparature(characteristic.value);
		let userConditionType = new UserConditionTypeModel();

		// userConditionType.userConditionTypeId = UserConditionType.Temperature;
		// userConditionType.isSystemType = true;

		console.log("Temperature: ", data.temperature + ' ' + data.unit);

		let temp = data.unit == 'Fahrenheit' ? (data.temperature - 32) * 5 / 9 : data.temperature;
		this.handleChange(userConditionType, (Math.round(temp * 100) / 100) + ' ');
		this.setState({
			isLoading: false,
		});
	}

	condTypeTemplate(option) {
		return (
			<div style={{ borderBottom: '1px #ccc solid', marginBottom: '5px', fontSize: 15, paddingBottom: 5 }}>
				{option.label}
			</div>
		);
	}

	changeBluetoothValue = (value) => {
		this.setState({ bluetoothValue: value });
	}

	handleDateChange = (value) => {
		const condition: UserConditionTypeModel = { ...this.state.newConditionType };
		condition.conditionDate = value;
		clearInterval();
		this.setState({ newConditionType: { ...condition } })
	}

	handleValueChange = (value) => {
		if (value < 0) {
			return;
		}
		const condition: UserConditionTypeModel = { ...this.state.newConditionType };
		condition.userConditionValue = value;
		this.setState({ newConditionType: { ...condition } })
	}

	handleSaveAddButton = () => {
		let currentCondition = { ...this.state.currentCondition };
		let newConditionType = { ...this.state.newConditionType };
		let topNumber = this.state.topNumber;
		let bottomNumber = this.state.bottomNumber;
		if (currentCondition.userConditionTypeId == UserConditionType.BloodPressure && currentCondition.isSystemType) {
			newConditionType.userConditionValue = topNumber.toString() + "/" + bottomNumber.toString();
			let regExp = /^\d{1,3}\/\d{1,3}$/;
			if (+topNumber < +bottomNumber) {
				this.growlSecond.show({ severity: 'warning', summary: Translate("BottomNumberBigger") })
				return;
			}
			if (!newConditionType.userConditionValue.match(regExp)) {
				this.growlSecond.show({ severity: 'warning', summary: Translate("BloodPresureValid") })
				return;
			}
		}
		if (!newConditionType.conditionDate) {
			newConditionType.conditionDate = new Date().toUTCString();
		}
		clearInterval();
		currentCondition.userConditionTypes.push(newConditionType);
		this.setState({ currentCondition: currentCondition, newConditionType: new UserConditionTypeModel(), addNew: false, bottomNumber: 0, topNumber: 0 });
		let conditionTypes: Array<UserConditionTypeModel> = [];
		conditionTypes.push(newConditionType);
		this.handleSaveButton(false, conditionTypes);
	}

	handleClick = (e) => {
		e.preventDefault();
		this.setState({ popover: true, anchorEl: e.currentTarget });
	}

	disconnect = () => {
		if (this.heartRateCharacteristic) {
			this.disconnectCharacteristic(this.heartRateCharacteristic);
			this.heartRateCharacteristic = null;
		}

		if (this.temperatureCharacteristic) {
			this.disconnectCharacteristic(this.temperatureCharacteristic);
			this.temperatureCharacteristic = null;
		}
	}

	disconnectCharacteristic = (characteristic: any) => {
		if (characteristic.service.device.gatt.connected) {
			characteristic.service.device.gatt.disconnect();
		}
	}

	handleCancelBluetoothButton = () => {
		this.setState({
			bluetoothDialog: false, bluetoothValue: '', selectedType: new UserConditionTypeModel(),
			isBluetoothLogStart: false, heartRateChangeArray: new Array<UserConditionTypeModel>(0)
		}, () => this.disconnect());
	}

	addBluetoothValue = () => {
		let currentCond = { ...this.state.currentCondition };
		let currentTypes = [...currentCond.userConditionTypes];
		let newTypes = [...this.state.heartRateChangeArray];
		currentTypes.push(...newTypes);
		currentCond.userConditionTypes = currentTypes;
		this.setState({
			currentCondition: { ...currentCond }
		})
		this.handleCancelBluetoothButton();
		this.handleSaveButton(false, newTypes);
	}

	scannDevices = () => {
		this.handleUserConditionBluetoothClick(this.state.currentCondition.userConditionTypeId)
	}

	openBluetoothDialog = (event) => {
		event.preventDefault();
		this.setState({ bluetoothDialog: true })
	}

	paginataorClick = (page) => {
		this.setState({ page: page }, () => this.getCondition(page, this.state.numberOfRows, false));
	}

	deleteConditionType = (index: number) => {
		let condition: UserConditionModel = new UserConditionModel();
		condition = { ...this.state.currentCondition };
		let conditions: Array<UserConditionTypeModel> = condition.userConditionTypes ? [...condition.userConditionTypes] : new Array<UserConditionTypeModel>();
		let founded = conditions[index];
		conditions.splice(index, 1);
		condition.userConditionTypes = [...conditions];
		this.setState({ currentCondition: { ...condition }, isVisibleConfirmTypeDialog: false, deleteValidationMessage: '' }, () => this.onDeleteConditionType(founded));
	}

	onDeleteConditionType = (condition: UserConditionTypeModel) => {
		this.userConditionService.deleteConditionType(condition.userConditionToUserConditionTypeId)
			.then(
				data => {
					this.growl.show({ severity: 'success', summary: Translate('Deleted Successfully') });
					this.setState({ isLoading: false }, () => this.getCondition(1, this.state.numberOfRows, true));
				},
				error => {
					this.growl.show({ severity: 'error', summary: Translate(error.message) });
					this.setState({
						isLoading: false
					});
				});
	}

	deleteCondition = (id: number) => {
		this.setState({
			isVisibleConfirmDialog: false,
			isLoading: true
		});

		this.userConditionService.deleteCondition(id)
			.then(
				data => {
					this.growl.show({ severity: 'success', summary: Translate('Deleted Successfully') });
					this.setState({ isLoading: false });
					this.props.cancelClick(true)
				},
				error => {
					this.growl.show({ severity: 'error', summary: Translate(error.message) });
					this.setState({
						isLoading: false
					});
				});
	}

	handleDeleteClick = () => {
		let dialogHeader = HelperFunctions.getEnumLabel(this.state.currentCondition.userConditionTypeId, UserConditionType, true) +
			" " + "(" + HelperFunctions.getUnitByConditionType(this.state.currentCondition.userConditionTypeId) + ")";
		this.setState({
			isVisibleConfirmDialog: true,
			deleteValidationMessage: Translate('ConditionConfirm') + '?'
		});
	}

	handleDropdownChange = (id) => {
		let unitRange = new ConditionUnitRangeModel();
		let ranges = [...this.state.conditionUnitRanges];
		for (let unit of ranges) {
			if (unit.conditionUnitRangeId == id) {
				unitRange = unit;
			}
		}
		this.setState({ selectedRangeID: id, selectedRange: unitRange });
	}

	handleTimeDropdownChange = (id) => {
		let filters = { ...this.state.currentFilters };
		let canChooseDates = false;
		switch (id) {
			case TimePresetType.OneDay:
				filters.startDate = HelperFunctions.getDaysEarlier(new Date().toString(), 1).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.OneWeek:
				filters.startDate = HelperFunctions.getDaysEarlier(new Date().toString(), 7).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.OneMonth:
				filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 1).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.ThreeMonths:
				filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 3).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.SixMonths:
				filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 6).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.OneYear:
				filters.startDate = HelperFunctions.getMonthsEarlier(new Date().toString(), 12).toISOString();
				filters.endDate = new Date().toISOString();
				canChooseDates = false;
				break;
			case TimePresetType.Advanced:
				canChooseDates = true;
		}
		this.setState({ selectedTime: id, currentFilters: filters, canChooseDates: canChooseDates });
	}

	onEnter = (e) => {
		if (e.key === 'Enter' && this.state.newConditionType && this.state.newConditionType.userConditionValue && this.state.newConditionType.userConditionValue.trim() != '') {
			this.handleSaveAddButton()
		}
	}

	getPlaceHolder() {
		if (this.state.currentCondition && this.state.currentCondition.isSystemType) {
			switch (this.state.currentCondition.userConditionTypeId) {
				case UserConditionType.BloodPressure:
					return Translate('EnterBloodPressure');
				case UserConditionType.HeartRate:
					return Translate('EnterHeartRate');
				case UserConditionType.Height:
					return Translate('EnterHeight');
				case UserConditionType.Temperature:
					return Translate('EnterTemperature');
				case UserConditionType.BloodSugar:
					return Translate('EnterBloodSugar');
				default:
					return '';
			}
		}
	}

	handleBloodPresusreValueChange = (value, isBottom) => {
		if (isBottom) {
			this.setState({ bottomNumber: value });
		}
		else {
			this.setState({ topNumber: value });
		}
	}

	getColor = (type: UserConditionTypeModel) => {
		const { currentCondition, selectedRange } = this.state;
		let returnedString: string = '#7bc87b';
		if (selectedRange) {
			if (currentCondition.isSystemType && currentCondition.userConditionTypeId == UserConditionType.BloodPressure) {
				let bPressure = type.userConditionValue.split('/');
				if ((selectedRange.minValue && +selectedRange.minValue > +bPressure[0]) ||
					(selectedRange.maxValue && +selectedRange.maxValue < +bPressure[0]) ||
					(selectedRange.secondMinValue && +selectedRange.secondMinValue > +bPressure[1]) ||
					(selectedRange.secondMaxValue && +selectedRange.secondMaxValue < +bPressure[1])) {
					returnedString = '#ff4d4d';
				}
			}
			else {
				if ((selectedRange.minValue && +selectedRange.minValue > +type.userConditionValue) ||
					(selectedRange.maxValue && +selectedRange.maxValue < +type.userConditionValue)) {
					returnedString = '#ff4d4d';
				}
			}
		}
		return returnedString;
	}

	toggleFilterDialog = (open) => {
		this.setState({
			isVisibleFilterDialog: open
		});
	};

	handleFilterChange = (key, value) => {
		const userFilter: UserConditionTypeFilterModel = { ...this.state.currentFilters };
		userFilter[key] = value;
		this.setState({ currentFilters: { ...userFilter } })
	};

	handleFilter = (e) => {
		e.preventDefault();
		let filters = { ...this.state.currentFilters };
		if (!filters.startDate) {
			filters.startDate = HelperFunctions.getDaysEarlier(new Date().toString(), 1).toISOString();
		}
		if (!filters.endDate) {
			filters.endDate = new Date().toISOString();
		}
		this.setState({ isVisibleFilterDialog: false, filters: filters, filterByDates: true }, () => this.getCondition(1, this.state.numberOfRows, true));
	}

	showFilters = (e) => {
		if (e) {
			e.preventDefault();
		}
		let currentSettings: UserConditionTypeFilterModel = new UserConditionTypeFilterModel();

		if (this.state.filters) {
			currentSettings = { ...this.state.filters };
		}

		if (!currentSettings.startDate) {
			this.handleTimeDropdownChange(this.state.selectedTime ? this.state.selectedTime : 1)
		}

		let timeDr = new Array<DropdownModel>(0);
		timeDr = HelperFunctions.enumToDropdownArray(TimePresetType, true);

		this.setState({ isVisibleFilterDialog: true, currentFilters: { ...currentSettings }, timeDropdown: timeDr });
	}

	clearFilters = (e?) => {
		if (e) {
			e.preventDefault();
		}
		this.setState({
			currentFilters: new UserConditionTypeFilterModel(), selectedTime: 1,
			filters: new UserConditionTypeFilterModel(), filterByDates: false, isVisibleFilterDialog: false
		},
			() => this.getCondition(1, this.state.numberOfRows, true))
	}

	getFiltersummary = () => {
		let startSet: any = null;
		let endSet: any = null;

		if (this.state.filters && this.state.filters.startDate) {
			startSet =
				<>
					<span style={{ color: '#999' }}>{Translate('From')}</span>:
			<span style={{ fontWeight: 600 }}> {HelperFunctions.fomatDateAsStringWithLang(new Date(this.state.filters.startDate), this.props.lang)} </span>
				</>
		}

		if (this.state.filters && this.state.filters.endDate) {
			endSet =
				<>
					<span style={{ color: '#999' }}>{Translate('To')}</span>:
			<span style={{ fontWeight: 600 }}> {HelperFunctions.fomatDateAsStringWithLang(new Date(this.state.filters.endDate), this.props.lang)} </span>
				</>
		}

		let summary =
			<p style={{ marginTop: 5, marginBottom: 0 }}>
				{startSet}
				{endSet}
			</p>

		return summary;
	}

	openInfoPopover = (e) => {
		e.preventDefault();

		this.setState({
			infoPopover: true,
			infoAchor: e.currentTarget
		});
	}

	handleInfoClose = () => {
		this.setState({
			infoPopover: false
		});
	}

	changeView = (view: boolean) => {
		localStorage.setItem('isChartView', view ? "true" : "false");
		this.setState({ isChartsView: view })
	}

	public render() {
		const { isLoading, currentCondition, isLoadingSecond, addNew, newConditionType, isVisibleDropdown,
			condIndex, page, numberOfPages, selectedRangeID, rangesDropdown, totalRecordsCount, from,
			isChartsView, bottomNumber, topNumber, currentFilters, filters, timeDropdown, selectedTime } = this.state;

		let condition = JSON.parse(JSON.stringify(currentCondition));
		let charts: any = null;
		let showAllLink = false;

		let label = condition.isSystemType ? HelperFunctions.getEnumLabel(condition.userConditionTypeId, UserConditionType, true) +
			' (' + condition.userConditionUnit + ')' + '' : condition.personalCondition + '';
		if (filters.startDate || filters.endDate) {
			showAllLink = true
		}

		if (currentCondition.userConditionTypes && currentCondition.userConditionTypes.length >= 1) {
			charts =
				isChartsView ?
					<div style={{ height: '300px', overflow: "hidden" }}>
						<UserConditionCharts
							userCondition={condition}
							typeRanges={this.state.selectedRange}
							lang={this.props.lang}
						/>
					</div> :
					<div>
						<div style={{ display: 'flex', marginTop: 15, marginLeft: 10 }}>
							<div style={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#7bc87b', marginRight: 5 }}></div>
							<span style={{ fontSize: 11 }}>{label}</span>
						</div>

						<div style={{ height: '300px', overflow: "hidden" }}>
							<UserConditionBars
								userCondition={condition}
								typeRanges={this.state.selectedRange}
								lang={this.props.lang}
							/>
						</div>
					</div>
				;
		}

		// if (currentCondition.isSystemType && currentCondition.userConditionTypeId == UserConditionType.BloodPressure &&
		// 	currentCondition.userConditionTypes && currentCondition.userConditionTypes.length >= 1) {
		// 	charts =
		// 		<div style={{ height: '300px', overflow: "hidden" }}>
		// 			<UserConditionCharts
		// 				userCondition={condition}
		// 				typeRanges={this.state.selectedRange}
		// 				lang={this.props.lang}
		// 			/>
		// 		</div>
		// 		;
		// }

		let dialogHeader = HelperFunctions.getEnumLabel(currentCondition.userConditionTypeId, UserConditionType, true) +
			" " + "(" + HelperFunctions.getUnitByConditionType(currentCondition.userConditionTypeId) + ")";

		if (!currentCondition.isSystemType) {
			dialogHeader = currentCondition.personalCondition;
		}

		return (
			<>
				<Dialog
					open={this.props.isVisible}
					onClose={this.handleCancelButton}
					fullWidth
					aria-labelledby="responsive-dialog-title"
				>
					<Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>
						{dialogHeader}</Modal.DialogTitle>
					<Modal.DialogContent>
						{isLoading ? <Spinner /> : null}
						<div style={{ minHeight: 200, minWidth: window.innerWidth < Constants.device.desktop ? 'unset' : 400, maxHeight: 600 }}>
							<Growl ref={(el) => this.growl = el} />

							{this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
							<div style={{ display: 'flex', marginBottom: 10, alignItems: 'center' }}>
								{currentCondition.userConditionTypes && currentCondition.userConditionTypes.length >= 1 ?
									<div style={{ minWidth: 105, display: 'flex' }}>
										<div className="chart-buttons" style={{
											borderRadius: "3px 0px 0px 3px",
											backgroundColor: isChartsView ? "#2196f3" : "#dedede"
										}}
											onClick={() => {
												localStorage.setItem('isChartView', 'true');
												this.setState({ isChartsView: true })
											}}>
											<a style={{ color: isChartsView ? "white" : "#007ad9" }}>
												<FontAwesomeIcon icon={faChartLine} />
											</a>
										</div>
										<div className="chart-buttons" style={{
											borderRadius: "0px 3px 3px 0px",
											backgroundColor: isChartsView ? "#dedede" : "#2196f3"
										}}
											onClick={() => {
												localStorage.setItem('isChartView', 'false');
												this.setState({ isChartsView: false })
											}}>
											<a style={{ color: isChartsView ? "#007ad9" : "white" }}>
												<FontAwesomeIcon icon={faChartBar} />
											</a>
										</div>

										{/* <a href="" style={{ opacity: isChartsView ? 1 : 0.5 }}
										onClick={(e) => {
											e.preventDefault();
											this.setState({ isChartsView: true })
										}}><FontAwesomeIcon icon={faChartLine} /></a>
									<a href="" style={{ opacity: isChartsView ? 0.5 : 1 }}
										onClick={(e) => {
											e.preventDefault();
											this.setState({ isChartsView: false })
										}}><FontAwesomeIcon icon={faChartBar} /></a> */}
									</div> : null}
								{isVisibleDropdown ?
									<div style={{ width: '100%', display: "flex", flexDirection: "row-reverse" }}>
										<div style={{ marginRight: 5, marginLeft: 10, display: 'flex', alignItems: 'center' }}>
											<span
												aria-describedby={"info-pop"}>
												<a href='' onClick={(e) => this.openInfoPopover(e)}>
													<FontAwesomeIcon
														icon={faInfoCircle}
														style={{ fontSize: '1.3em', margin: '0 2px' }}
													/>
												</a>
											</span>
										</div>
										<Popover
											id={"info-pop"}
											open={this.state.infoPopover}
											anchorEl={this.state.infoAchor}
											onClose={this.handleInfoClose}
											anchorOrigin={{
												vertical: 'top',
												horizontal: 'right',
											}}
											transformOrigin={{
												vertical: 'bottom',
												horizontal: 'right',
											}}
										>
											<div style={{ padding: 20, minWidth: 250 }}>
												<h4>{Translate("NormInfoPopMessage")}</h4>
											</div>
										</Popover>
										<div style={{ width: window.innerWidth < Constants.device.desktop ? '100%' : 200 }}>
											<FormControl>
												<Select
													value={selectedRangeID}
													onChange={(e) => this.handleDropdownChange(e.target.value)}
													inputProps={{
														id: 'condition-type-label'
													}}>
													{rangesDropdown.map(m => <MenuItem key={m.value + 'condTypeItem'}
														value={m.value}>{m.value ? m.label : <em>{m.label}</em>}</MenuItem>)}
												</Select>
											</FormControl>
										</div>
									</div>
									: null}
							</div>
							{charts}
							<div style={{ textAlign: 'center' }}>
								<Paginator numberOfPages={numberOfPages} page={page} paginataorClick={this.paginataorClick} onlyArrows={true} />
							</div>
							<Card className="prescription-card">
								<CardContent>
									<div style={{ display: 'flex', marginBottom: '20px' }}>
										<div style={{ marginRight: 10 }}>
											<Fab color="primary" aria-label="Add" size="small" onClick={(e) => this.addNewToList(e)}>
												<AddIcon />
											</Fab>
										</div>
										<div style={{ marginRight: 10 }}>
											<Fab color="primary" aria-label="Add" size="small" onClick={(e) => this.showFilters(e)}>
												<FontAwesomeIcon icon={faFilter} />
											</Fab>
										</div>
										{currentCondition.isSystemType && currentCondition.userConditionTypeId == UserConditionType.HeartRate ?
											<div>
												<Fab color="primary" aria-label="Add" size="small" onClick={(e) => this.openBluetoothDialog(e)}>
													<FontAwesomeIcon icon={faBluetooth} />
												</Fab>
											</div> : null}
									</div>
									<div style={{ fontSize: '0.95em', color: '#999' }}>
										<span className='list-items-count-info-number'>{totalRecordsCount + " "}</span>{Translate('TotalResults')}
									</div>
									{this.state.filterByDates ?
										this.getFiltersummary()
										: null}

									{showAllLink ?
										<div style={{ margin: '10px 0' }}>
											<a href='' onClick={(e) => this.clearFilters(e)}>{Translate('See All')}</a>
										</div> : null}
									<div style={{ minHeight: '100px', maxHeight: '200px', overflowY: 'auto', paddingRight: '5px' }}>
										<ul className="list-items" style={{ marginTop: '15px' }}>
											{currentCondition && currentCondition.userConditionTypes && currentCondition.userConditionTypes.length > 0 ?
												currentCondition.userConditionTypes
													.sort((a, b) => new Date(b.conditionDate).getTime() - new Date(a.conditionDate).getTime())
													.map((m: UserConditionTypeModel, index) =>
														<li key={index + 'condToType'}>
															{this.state.conditionUnitRanges && this.state.conditionUnitRanges.length > 0 ?
																<div className="item-icon">
																	<FontAwesomeIcon icon={faCircle} color={this.getColor(m)}></FontAwesomeIcon>
																</div>
																: null}
															<div className="item-info">
																<div className="item-name" style={{ fontWeight: 600 }}>
																	{m.userConditionValue + " " +
																		(currentCondition.isSystemType ? HelperFunctions.getUnitByConditionType(currentCondition.userConditionTypeId) : "")}
																</div>
																<div className="item-desc">
																	{HelperFunctions.fomatDateTimeSecondsAsStringWithLang(new Date(m.conditionDate), this.props.lang)}
																</div>
															</div>
															<div className="item-actions" style={{ paddingLeft: 5 }}>
																<span>
																	<a href='' onClick={(e) => this.handleUserConditionTypeRemoveClick(e, index)} >
																		<FontAwesomeIcon icon={faTimesCircle} style={{ color: '#f50057', fontSize: '1.3em', margin: '0 2px' }} />
																	</a>
																</span>
															</div>
														</li>
													) : null}
											{(!currentCondition || !currentCondition.userConditionTypes || currentCondition.userConditionTypes.length <= 0) &&
												(!filters || !filters.startDate || !filters.endDate) ?
												<span style={{ color: 'rgba(0, 0, 0, 0.54)' }}><i>{Translate("Add Characteristic")}</i></span>
												: null}
										</ul>
									</div>
								</CardContent>
							</Card>
						</div>

					</Modal.DialogContent>
					<Modal.DialogActions>
						<div style={{ display: 'flex', width: '100%' }}>
							<div style={{ width: 100 }}>
								<Button variant="contained" size="small" color="secondary" onClick={this.handleDeleteClick} style={{ marginRight: '10px' }}>
									{Translate('Delete')}
								</Button>
							</div>
							<div style={{ width: '100%', textAlign: 'right' }}>
								<Button variant="contained" size="small" onClick={this.handleCancelButton}>
									{Translate('Close')}
								</Button>
							</div>
							{/* <Button variant="contained" size="small" color="primary" onClick={(e) => this.handleSaveButton(e, true)}
								disabled={!currentCondition || !currentCondition.userConditionTypes || currentCondition.userConditionTypes.length == 0}>
								<FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
								{Translate('Save')}
							</Button> */}
						</div>
					</Modal.DialogActions>
				</Dialog>

				<MuiThemeProvider theme={Constants.smallDialogTheme}>
					{addNew ?
						<Dialog
							open={addNew}
							onClose={this.handleCancelAddNewButton}
							fullWidth={window.innerWidth < Constants.device.desktop}
						>
							<Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelAddNewButton}>{Translate("AddValue")}</Modal.DialogTitle>
							<Modal.DialogContent>
								{isLoadingSecond ? <Spinner /> : null}
								<Growl ref={(el) => this.growlSecond = el} />
								<div style={{ marginBottom: '10px' }}>
									<MuiPickersUtilsProvider utils={DateFnsUtils}>
										<DateTimePicker
											autoOk
											ampm={false}
											disableFuture
											format={"dd.MM.yyyy г. HH:mm ч."}
											margin="normal"
											label={Translate('Date')}
											value={newConditionType.conditionDate ? new Date(newConditionType.conditionDate) : new Date()}
											onChange={(e) => this.handleDateChange(e)}
										/>
									</MuiPickersUtilsProvider>
								</div>
								{currentCondition.isSystemType && currentCondition.userConditionTypeId == UserConditionType.BloodPressure ?
									<div style={{ width: '100%', display: 'flex' }}>
										<TextField
											name="value"
											autoComplete="off"
											label={Translate('TopNumber')}
											//placeholder={this.getPlaceHolder()}
											type={'number'}
											value={topNumber ? topNumber : ''}
											onChange={(e) => this.handleBloodPresusreValueChange(e.target['value'], false)}
											onKeyPress={this.onEnter}
											style={{ flexWrap: 'wrap', marginRight: 5 }}
										/>
										<TextField
											name="value"
											autoComplete="off"
											label={Translate('BottomNumber')}
											//placeholder={this.getPlaceHolder()}
											type={'number'}
											value={bottomNumber ? bottomNumber : ''}
											onChange={(e) => this.handleBloodPresusreValueChange(e.target['value'], true)}
											onKeyPress={this.onEnter}
											style={{ flexWrap: 'wrap', marginLeft: 5 }}
										/>
									</div>
									:
									<div>
										<TextField
											name="value"
											autoComplete="off"
											label={Translate('Value')}
											placeholder={this.getPlaceHolder()}
											type={"number"}
											value={newConditionType && newConditionType.userConditionValue ? newConditionType.userConditionValue : ""}
											onChange={(e) => this.handleValueChange(e.target['value'])}
											onKeyPress={this.onEnter}
										/>
									</div>
								}

							</Modal.DialogContent>
							<Modal.DialogActions>
								<div>
									<Button variant="contained" size="small" onClick={this.handleCancelAddNewButton} style={{ marginRight: '10px' }}>
										<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
										{Translate('Cancel')}
									</Button>
									<Button variant="contained" size="small" color="primary" onClick={this.handleSaveAddButton}
										disabled={!newConditionType ||
											(((currentCondition.isSystemType && currentCondition.userConditionTypeId != UserConditionType.BloodPressure) || !currentCondition.isSystemType)
												&& (!newConditionType.userConditionValue || newConditionType.userConditionValue.trim() == ''))
											|| (currentCondition.isSystemType && currentCondition.userConditionTypeId == UserConditionType.BloodPressure &&
												(!topNumber || !bottomNumber))}>
										<FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
										{Translate('Save')}
									</Button>
								</div>
							</Modal.DialogActions>
						</Dialog>
						: null}

					{this.state.bluetoothDialog ?
						<Dialog
							open={this.state.bluetoothDialog}
							onClose={this.handleCancelBluetoothButton}
							fullWidth={window.innerWidth < Constants.device.desktop}
						>
							<Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelBluetoothButton}>{Translate("Connect with a device")}</Modal.DialogTitle>
							<Modal.DialogContent style={{ width: window.innerWidth < Constants.device.desktop ? 'unset' : 400 }}>
								{this.state.isLoadingBluetooth ? <Spinner /> : null}
								<Growl ref={(el) => this.growlBluetooth = el} />
								<Button style={{ marginTop: 10 }} variant="contained" size="small" color="primary" onClick={this.scannDevices}>
									{Translate('Scan')}
								</Button>
								<div style={{ marginTop: 20, marginBottom: 20 }}>
									{this.state.bluetoothValue && this.state.bluetoothValue != '' ?
										<div style={{ display: 'flex', alignItems: 'center' }}>
											<span>{Translate('Current value')}:
											<span style={{ fontWeight: 600, fontSize: 20 }}> {this.state.bluetoothValue} {HelperFunctions.getUnitByConditionType(this.state.currentCondition.userConditionTypeId)}</span>
											</span>
											<div style={{ marginLeft: 20 }}>
												{!this.state.isBluetoothLogStart ?
													<Fab color="secondary" aria-label="Add" size="small" onClick={(e) => this.setState({ isBluetoothLogStart: true })}>
														<FontAwesomeIcon icon={faPlay} />
													</Fab>
													:
													<Fab color="primary" aria-label="Add" size="small" onClick={(e) => this.setState({ isBluetoothLogStart: false })}>
														<FontAwesomeIcon icon={faStop} />
													</Fab>}
											</div>
										</div>
										: <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}><i>{Translate('No current value')}</i></span>}

									{this.state.isBluetoothLogStart ? <div style={{ fontSize: '0.95em', color: '#999', marginBottom: 10 }}>{Translate('ReceivingData')}</div> : null}
									{this.state.heartRateChangeArray && this.state.heartRateChangeArray.length > 0 ?
										<div>{Translate('ReceivedData')}:
											<span className='list-items-count-info-number'>{" " + this.state.heartRateChangeArray.length}</span>
										</div> : null}
								</div>
							</Modal.DialogContent>
							<Modal.DialogActions>
								<div>
									<Button variant="contained" size="small" onClick={this.handleCancelBluetoothButton} style={{ marginRight: '10px' }}>
										<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
										{Translate('Cancel')}
									</Button>
									<Button variant="contained" size="small" color="primary" onClick={this.addBluetoothValue}
										disabled={!this.state.bluetoothValue && this.state.bluetoothValue.trim() == '' ||
											!this.state.heartRateChangeArray || this.state.heartRateChangeArray.length == 0}>
										<FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
										{Translate('Save')}
									</Button>
								</div>
							</Modal.DialogActions>
						</Dialog>
						: null}
				</MuiThemeProvider>
				{this.state.isVisibleFilterDialog ?
					<Dialog
						open={this.state.isVisibleFilterDialog}
						onClose={() => this.toggleFilterDialog(false)}
						fullWidth={window.innerWidth < Constants.device.desktop}
						aria-labelledby="responsive-dialog-title"
					>
						<Modal.DialogTitle id="customized-dialog-title" onClose={() => this.toggleFilterDialog(false)}>{Translate('Filters')}</Modal.DialogTitle>
						<Modal.DialogContent>
							<div style={{ minHeight: 200, minWidth: window.innerWidth < Constants.device.desktop ? 'unset' : 400 }}>
								<div style={{ marginBottom: 15 }}>
									<FormControl>
										<InputLabel htmlFor="preset-type-label">{Translate('Period')}</InputLabel>
										<Select
											value={selectedTime}
											onChange={(e) => this.handleTimeDropdownChange(e.target.value)}
											inputProps={{
												id: 'preset-type-label'
											}}>
											{timeDropdown.map(m => <MenuItem key={m.value + 'timeItem'}
												value={m.value}>{m.value ? m.label : <em>{m.label}</em>}</MenuItem>)}
										</Select>
									</FormControl>
								</div>
								{this.state.canChooseDates ?
									<>
										<div style={{ marginBottom: 15 }}>
											<label style={{ width: '100%' }}>{Translate('From')}:</label>
											<MuiPickersUtilsProvider utils={DateFnsUtils}>
												<DatePicker
													format={Translate('DateFormat')}
													margin="normal"
													value={this.state.currentFilters.startDate ? new Date(this.state.currentFilters.startDate) : HelperFunctions.getDaysEarlier(new Date().toString(), 1)}
													onChange={(e) => this.handleFilterChange('startDate', e)}
												/>
											</MuiPickersUtilsProvider>
										</div>
										<div>
											<label style={{ width: '100%' }}>{Translate('To')}:</label>
											<MuiPickersUtilsProvider utils={DateFnsUtils}>
												<DatePicker
													format={Translate('DateFormat')}
													margin="normal"
													value={this.state.currentFilters.endDate ? new Date(this.state.currentFilters.endDate) : new Date()}
													onChange={(e) => this.handleFilterChange('endDate', e)}
												/>
											</MuiPickersUtilsProvider>
										</div>
									</> :
									<>
										<div style={{ marginBottom: 15, display: 'flex', alignItems: 'flex-end' }}>
											<label style={{ width: 'unset', marginRight: 10 }}>{Translate('From')}:</label>
											<div style={{ fontSize: 15 }}>
												{HelperFunctions.fomatDateAsStringWithLang(this.state.currentFilters.startDate ?
													new Date(this.state.currentFilters.startDate) : HelperFunctions.getDaysEarlier(new Date().toString(), 1), this.props.lang)}
											</div>
										</div>
										<div style={{ display: 'flex', alignItems: 'flex-end' }}>
											<label style={{ width: 'unset', marginRight: 10 }}>{Translate('To')}:</label>
											<div style={{ fontSize: 15 }}>
												{HelperFunctions.fomatDateAsStringWithLang(this.state.currentFilters.endDate ?
													new Date(this.state.currentFilters.endDate) : new Date(), this.props.lang)}
											</div>
										</div>
									</>
								}
							</div>
						</Modal.DialogContent>
						<Modal.DialogActions>
							<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
								<div>
									<Button variant="contained" size="small" color="secondary"
										onClick={this.clearFilters}>
										<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
										{Translate('Clear')}
									</Button>
								</div>
								<div>
									<Button variant="contained" size="small" onClick={() => this.setState({ isVisibleFilterDialog: false })} style={{ marginRight: '5px' }}>
										<FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
										{Translate('Cancel')}
									</Button>
									<Button variant="contained" size="small" color="primary" onClick={(e) => this.handleFilter(e)}>
										<FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
										{Translate('Filtering')}
									</Button>
								</div>
							</div>
						</Modal.DialogActions>
					</Dialog> : null}

				<ConfirmDialog
					headerTitle={Translate("Confirm Dialog")}
					isVisible={this.state.isVisibleConfirmDialog}
					yesClick={() => { this.deleteCondition(this.state.currentCondition.userConditionId) }}
					noClick={() => { this.setState({ isVisibleConfirmDialog: false, deleteValidationMessage: '' }) }}>
					{this.state.deleteValidationMessage}
				</ConfirmDialog>

				<ConfirmDialog
					headerTitle={Translate("Confirm Dialog")}
					isVisible={this.state.isVisibleConfirmTypeDialog}
					yesClick={() => { this.deleteConditionType(condIndex) }}
					noClick={() => { this.setState({ isVisibleConfirmTypeDialog: false, deleteValidationMessage: '' }) }}>
					{this.state.deleteValidationMessage}
				</ConfirmDialog>
			</>
		)
	}
}

export default UserConditionAddEditDialog;

class ConditionDropdownModel {
	value: number;
	label: string;
	isSystem: boolean;
}